export default "__VITE_ASSET__Ddn_24rF__"